import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoaderService } from '../../services/loader.service';
import { ISTATACARD } from 'src/app/config/app-settings.config';
import { ThemeService } from 'src/app/services/theme.service';

export interface LoaderState {
  show: boolean;
}
@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit, OnDestroy {

  show = false;

  private subscription: Subscription;
  TATACARD= ISTATACARD;

  partnerCode: any = sessionStorage.getItem('partner-code');
  containerType: any = sessionStorage.getItem('container-type');
  
  constructor(
    private loaderService: LoaderService,
    private themeService: ThemeService
    ){
      this.partnerCode = this.themeService.partnerCode;
    }

  ngOnInit() {
    this.subscription = this.loaderService.loaderState
      .subscribe((state: LoaderState) => {
        this.show = state.show;
      });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
